module.exports = {
  title: 'Airbnb Flip Interaction with Reanimated',
  author: 'Enzo Manuel Mangano',
  date: '2025-09-02',
  slug: 'airbnb-flip-interaction',
  tags: ['reanimated', 'expo-blur'],
};
